<template>
    <div id="container" class="container">
        <myheader2 name="主页"></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="profile-box">
                        <div class="top-box">
                            <!-- <div class="verify-box flex-r-s-c">
                                <div class="icon-box">
                                    <img class="icon-img" src="../../../static/user_acc_verify.png" alt="">
                                </div>
                                <div class="t1">账户正常</div>
                            </div> -->
                            <div class="pr-box flex-r-s-c">
                                <div class="avatar-box">
                                    <img class="avt-img" src="../../../static/face.png" alt="">
                                </div>
                                <div class="info-box">
                                    <div class="info-li1 flex-r-s-c">
                                        <div class="name-box">{{baseInfo.username || ''}}</div>
                                        <div v-if="baseInfo.level_name" class="level-box">{{baseInfo.level_name || ''}}</div>
                                    </div>
                                    <div class="info-li2 flex-r-s-c">
                                        <div class="time-box">
                                            到期时间：2026-07-01
                                        </div>
                                        <div @click="openVipDialog" class="xy-btn-box cur ">【立即续约】</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-box">
                            <div class="flex-r-b-c bt-list">
                                <div class="bt-li">
                                    <div class="text-box">
                                        <div class="t1-t">{{baseInfo.cnt1 || 0}}</div>
                                        <div class="t2-t">已备案作品</div>
                                    </div>
                                </div>
                                <div class="bt-li">
                                    <div class="text-box">
                                        <div class="t1-t"><span>￥{{baseInfo.cnt2 || ''}}</span><span class="unit">万</span></div>
                                        <div class="t2-t">作品评估总值</div>
                                    </div>
                                </div>
                                <div class="bt-li">
                                    <div class="text-box">
                                        <div class="t1-t">{{baseInfo.cnt3 || 0}}</div>
                                        <div class="t2-t">处理中申请</div>
                                    </div>
                                </div>
                                <div class="bt-li noline">
                                    <div class="text-box">
                                        <div class="t1-t">{{baseInfo.cnt4 || 0}}</div>
                                        <div class="t2-t">剩余备案次数</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="work-block">
                        <div class="work-outer">
                            <workList ref="workTemp"></workList>
                        </div>
                    </div>
                </div>
                <!-- <el-row :gutter="20" :type="colwrap?'':'flex'">
				<el-col :xs="24" :sm="24" :md="12" :lg="8">
					<div class="item item1">
						<div class="pd">
							<div class="t">{{ baseInfo.cnt1 || 0 }}</div>
							<div class="t2">已备案资产</div>
							<div class="t3">每一件都拥有唯一的区块链ID，可追溯，可信赖。</div>
						</div>
					</div>
				</el-col>
			</el-row> -->
            </div>
        </div>
        <openvip ref="vipDialog"></openvip>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js";
import workList from "../components/workList.vue";
import openvip from "@/components/openVip/openVip"

export default {
    name: "userCenter",
    components: {
        workList,
        openvip
    },
    data() {
        return {
            baseInfo: {
                username: "",
                level_name: "",
                status: "",
                cnt1: 0,
                cnt2: 0,
                cnt3: 0,
                cnt4: 0
            }
        }
    },
    created() {
        that = this;
    },
    mounted() {
        this.$refs.workTemp.initData()
        this.initData()
    },
    methods: {
        initData() {
            ty.ajax("web/goods/goods/home", {}).then((result) => {
                that.baseInfo = result.data
            });
        },
        goPage(path) {
            util.tourl(path)
        },
        openVipDialog() {
            this.$refs.vipDialog.openvip();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './index.scss';
</style>